import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import UIAlert from 'UIComponents/alert/UIAlert';
import ObjectNameReference from 'automation-ui-enrollment/components/filters/enrollment/generic-enrollment-table/ObjectNameReference';
import { ExecutionStates } from 'automation-ui-log-events/constants/LogEventConstants';
import LogEventMessage from 'automation-ui-log-events/components/LogEventMessage';
import { jsx as _jsx } from "react/jsx-runtime";
const EmailActionPreviewAlert = ({
  objectId,
  flowObjectTypeId,
  logEvent
}) => {
  if (logEvent.executionState === ExecutionStates.FAIL_CONTINUE) {
    return /*#__PURE__*/_jsx(UIAlert, {
      use: "inline",
      type: "tip",
      className: "m-bottom-2",
      children: /*#__PURE__*/_jsx(LogEventMessage, {
        logEvent: logEvent,
        flowObjectTypeId: flowObjectTypeId
      })
    });
  }
  const objectName = /*#__PURE__*/_jsx(ObjectNameReference, {
    id: objectId,
    objectTypeId: flowObjectTypeId
  });
  return /*#__PURE__*/_jsx(UIAlert, {
    use: "inline",
    type: "tip",
    className: "m-bottom-2",
    children: /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "automation-ui-action-features.action-features.email.action-preview.alert",
      options: {
        objectName
      }
    })
  });
};
export default EmailActionPreviewAlert;